import { getReferenceData, setReferenceData } from 'helpers';
import { getHeaderOptions, getHttpService } from './http-service';

const httpClient = getHttpService();

const FORM_SERVICE_BASE_ROUTE = '/form';

export const getAllForms = () => {
  return httpClient.get(`${FORM_SERVICE_BASE_ROUTE}/`, {
    headers: getHeaderOptions(),
  });
};

export const getFormById = async (id: string) => {
  const { items = [] } = getReferenceData('formDefinition');
  const formDefinition = items.find(R.propEq('id', id));

  if (formDefinition) {
    return { data: formDefinition };
  }

  const { data } = await httpClient.get(`${FORM_SERVICE_BASE_ROUTE}/${id}`, {
    headers: getHeaderOptions(),
  });

  setReferenceData(R.append(data, items), 'formDefinition');
  return { data };
};

export const submitForm = (formData: any) => {
  return httpClient.post(`${FORM_SERVICE_BASE_ROUTE}/submit`, formData, {
    headers: getHeaderOptions(),
  });
};

// The partner-insights survey definition is generated per-request on the
// backend (no row in the form-definition table), so we prefill the
// reference-data cache that getFormById reads from. FormEngine then resolves
// the definition from cache by formId without hitting the GET-by-id endpoint
// that would 404 for this id.
export const getActivePartnerInsightsSurvey = async (policyType?: string) => {
  const { data } = await httpClient.get(
    `${FORM_SERVICE_BASE_ROUTE}/insights/active`,
    {
      headers: getHeaderOptions(),
      params: policyType ? { policyType } : undefined,
    },
  );

  if (data && data.active && data.formDefinition) {
    const { items = [] } = getReferenceData('formDefinition');
    const existing = items.filter(R.propEq('id', data.formDefinition.id));
    if (existing.length === 0) {
      setReferenceData(R.append(data.formDefinition, items), 'formDefinition');
    } else {
      // Refresh in place so a partner change in mid-session picks up the
      // new interpolated labels.
      setReferenceData(
        items.map((d) =>
          d.id === data.formDefinition.id ? data.formDefinition : d,
        ),
        'formDefinition',
      );
    }
  }

  return data;
};

